// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__207_p","productName":"Table_productName__1U9Pb"};